import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import typographyStyle from "assets/jss/material-dashboard-react/components/typographyStyle.jsx";

function Mono({ ...props }) {
    const { classes, children } = props;
    return (
        <div className={classes.monoFontStyle + " " + classes.darkMutedText}>
            {children}
        </div>
    );
}

Mono.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(typographyStyle)(Mono);



// WEBPACK FOOTER //
// ./src/components/Typography/Mono.jsx